
export class OroCounty {

  public Id: number = 0;
  public Name: string = '';
  public State: string = '';
}
